<div id="bookingsTop" class="General">
  <br>
  <br>
  <!-- <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=SHJZBzjqG0WKvqY47dusgZ0k5CTcHDNJvR5V--t1mNlUNVdMVFVaRjE0RE05MDRHUUVBQzlLSEM3SS4u" target="_blank">
    <alert  type="success">
      <strong>Click Here for Assessor Online Appointment - User Acceptance Testing Questionnaire</strong>
    </alert>
  </a> -->
  <h3 style="font-size: 1.8rem;" class="page-title">{{ 'Booking.PageTitle' | translate}}</h3>
  <!-- <p><strong>{{ 'Booking.Forthefollowing' | translate}}</strong>
  <p><a href="contact/assessor/2"><u>{{ 'Booking.Homeowners' | translate}}</u></a> {{ 'Booking.Homeownersdesc' | translate}} <br>
  <a href="contact/assessor/4"><u>{{ 'Booking.Prop19' | translate}}</u></a> {{ 'Booking.Prop19desc' | translate}}<br>
  <a href="contact/assessor/2"><u>{{ 'Booking.Ownership' | translate}}</u></a> {{ 'Booking.Ownershipdesc' | translate}}<br>
  <a href="contact/assessor/5"><u>{{ 'Booking.Exemption' | translate}}</u></a> {{ 'Booking.Exemptiondescv2' | translate}}<br>
  <a href="contact/assessor/3"><u>{{ 'Booking.BusinessInq' | translate}}</u></a> {{ 'Booking.Buisinessdesc' | translate}}</p>
  <p><i>{{ 'Booking.Thecontactformv3' | translate}}</i></p> -->
  <p>{{ 'Booking.Theonlinev3' | translate}}</p>
  <!-- <p><strong>{{ 'Booking.Note' | translate}}</strong> {{ 'Booking.Pleasebev2' | translate}} {{ 'Booking.Forfurtherv2' | translate}} <a href="contact/assessor/1"><u>{{ 'Booking.Contact' | translate}}</u></a></p> -->
  <p [innerHTML]="'Booking.ContactForm3' | translate"></p>

  <div class="row">
    @for (appointmentInfo of appointmentInfos; track appointmentInfo.routerLink) {
      <div class="col-md-4 col-sm-6 d-flex align-items-stretch">
        <a class="w-100" (click)="routeToLink(appointmentInfo.routerLink)">
          <div  class="card grow" >
            <div class="card-body">
              <p class="card-title ">{{appointmentInfo.title}}</p>
              <div class="docs-guide-card-divider">
              </div>
              <p>{{ appointmentInfo.description | translate}}</p>
            </div>
          </div>
        </a>
      </div>
    }
  </div>


  <!-- <a class="w-100" (click)="routeToLink('')"> -->

  <div style="height: 25px"></div>
</div>
